/** Portal attendance day display status → Tailwind classes (dark-mode safe). */
export const ATTENDANCE_STATUS_STYLES = {
  present: 'bg-emerald-500/20 text-emerald-700 dark:text-emerald-300 border-emerald-500/40',
  absent: 'bg-red-500/20 text-red-700 dark:text-red-300 border-red-500/40',
  leave: 'bg-orange-500/20 text-orange-700 dark:text-orange-300 border-orange-500/40',
  leave_pending: 'bg-amber-500/25 text-amber-800 dark:text-amber-200 border-amber-500/50',
  leave_rejected: 'bg-red-500/15 text-red-600 dark:text-red-400 border-red-500/30',
  leave_more_info: 'bg-violet-500/20 text-violet-700 dark:text-violet-300 border-violet-500/40',
  holiday: 'bg-blue-500/20 text-blue-700 dark:text-blue-300 border-blue-500/40',
  weekend: 'bg-muted text-muted-foreground border-border',
  late: 'bg-emerald-500/15 text-emerald-600 dark:text-emerald-400 border-emerald-500/30',
  half_day: 'bg-amber-500/20 text-amber-700 dark:text-amber-300 border-amber-500/40',
  empty: 'bg-transparent border-transparent',
};

export const ATTENDANCE_STATUS_LABELS = {
  present: 'Present',
  absent: 'Absent',
  leave: 'Leave',
  leave_pending: 'Leave pending',
  leave_rejected: 'Leave rejected',
  leave_more_info: 'More info',
  holiday: 'Holiday',
  weekend: 'Weekend',
  late: 'Late',
  half_day: 'Half day',
  empty: '',
};

export const LEAVE_STATUS_LABELS = {
  pending_class_teacher: 'Awaiting class teacher',
  pending_admin: 'Awaiting admin',
  pending: 'Pending',
  approved: 'Approved',
  rejected: 'Rejected',
  more_info: 'More info needed',
};

export function statusLabel(displayStatus) {
  if (displayStatus in ATTENDANCE_STATUS_LABELS) {
    return ATTENDANCE_STATUS_LABELS[displayStatus];
  }
  return displayStatus ?? '—';
}
